import { render, staticRenderFns } from "./SurveyPostPresentation.vue?vue&type=template&id=515bc02a&scoped=true&"
import script from "./SurveyPostPresentation.vue?vue&type=script&lang=js&"
export * from "./SurveyPostPresentation.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPostPresentation.vue?vue&type=style&index=0&id=515bc02a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515bc02a",
  null
  
)

export default component.exports